import { types } from 'mobx-state-tree'

import {
  IActivity,
  ICommunicationActivityJSON,
  IDocumentUploadActivity,
  IMessageActivityJSON,
  IProductUpdateActivityJSON,
  TActivity,
} from './activities/Activity'
import { BaseActivity } from './activities/BaseActivity'
import { isDocumentActivity, TDocumentUploadActivity } from './activities/DocumentUploadActivity'
import { ISubscriptionActivity } from './activities/SubscriptionActivity'
import { ActorsJSON } from './Actors'
import { SubscriptionModel } from './subscriptions/SubscriptionModel'

export interface IActivityFeedJSON {
  actors: ActorsJSON
  activities: Array<
    IActivity | ICommunicationActivityJSON | IMessageActivityJSON | IDocumentUploadActivity | IProductUpdateActivityJSON
  >
  subscription: {
    freightieIds: string[]
    userIds: string[]
    modifiedAt: string
  }
}
export const ActivityFeed = types
  .compose(
    types.model('ActivityFeed', {
      activities: types.array(BaseActivity),
    }),
    SubscriptionModel
  )
  .views((self) => ({
    get isInitialBooking() {
      if (self.activities.length === 0) {
        return true
      }
      return self.activities.length === 1 && self.activities[0].type === 'booking'
    },
    get deletedDocuments(): TDocumentUploadActivity[] {
      return self.activities.filter(
        (activity) => isDocumentActivity(activity) && activity.action === 'deleted'
      ) as TDocumentUploadActivity[]
    },
  }))
  .actions((self) => ({
    addActivity(data: { activity: IActivity; actors: ActorsJSON }) {
      const { activity, actors } = data

      const updateMembers = (activity: ISubscriptionActivity) => {
        const type = activity.userAuthor_id ? 'userId' : 'freightieId'
        const id = activity.userAuthor_id || activity.freightieAuthor_id
        if (activity.action === 'left') {
          // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
          self.subscription.removeSubscriber(id, type)
        } else {
          // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
          self.subscription.addSubscriber(id, type)
        }
      }

      if (actors != null) {
        self.actors.addActors(actors)
      }

      if (activity.type === 'subscription') {
        const subscriptionActivity = activity as ISubscriptionActivity
        updateMembers(subscriptionActivity)
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
      self.activities.unshift(activity as any as TActivity)
    },
  }))

export type TActivityFeed = typeof ActivityFeed.Type
